/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Co_OrganizerInputs */

const th_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เชิญผู้ร่วมจัด`)
};

const en_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite a co-organiser`)
};

const ja_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共同主催者を招待`)
};

const zh_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀请联合主办方`)
};

const es_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitar a un coorganizador`)
};

const pt_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convidar um coorganizador`)
};

const id_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undang penyelenggara pendamping`)
};

const fr_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviter un coorganisateur`)
};

const tl_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-anyaya ng co-organizer`)
};

const vi_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mời người đồng tổ chức`)
};

const ko_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공동 주최자 초대`)
};

const de_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitveranstalter einladen`)
};

const ru_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пригласить соорганизатора`)
};

const tr_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yardımcı düzenleyici davet et`)
};

const it_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invita un co-organizzatore`)
};

const pl_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaproś współorganizatora`)
};

const uk_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запросити співорганізатора`)
};

const hi_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सह-आयोजक को आमंत्रित करें`)
};

const ar_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دعوة منظّم مشارك`)
};

const ms_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jemput penganjur bersama`)
};

const bn_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সহ-আয়োজক আমন্ত্রণ করুন`)
};

const zh_tw2_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀請共同主辦`)
};

const zh_hk2_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀請共同主辦`)
};

const ur_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شریک منتظم کو مدعو کریں`)
};

const fa_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دعوت هم‌برگزارکننده`)
};

const sw_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alika mwandalizi mwenza`)
};

const nl_invite_co_organizer = /** @type {(inputs: Invite_Co_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mede-organisator uitnodigen`)
};

/**
* | output |
* | --- |
* | "Invite a co-organiser" |
*
* @param {Invite_Co_OrganizerInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const invite_co_organizer = /** @type {((inputs?: Invite_Co_OrganizerInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Co_OrganizerInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_invite_co_organizer(inputs)
	if (locale === "ja") return ja_invite_co_organizer(inputs)
	if (locale === "zh") return zh_invite_co_organizer(inputs)
	if (locale === "es") return es_invite_co_organizer(inputs)
	if (locale === "pt") return pt_invite_co_organizer(inputs)
	if (locale === "id") return id_invite_co_organizer(inputs)
	if (locale === "fr") return fr_invite_co_organizer(inputs)
	if (locale === "tl") return tl_invite_co_organizer(inputs)
	if (locale === "vi") return vi_invite_co_organizer(inputs)
	if (locale === "ko") return ko_invite_co_organizer(inputs)
	if (locale === "de") return de_invite_co_organizer(inputs)
	if (locale === "ru") return ru_invite_co_organizer(inputs)
	if (locale === "tr") return tr_invite_co_organizer(inputs)
	if (locale === "it") return it_invite_co_organizer(inputs)
	if (locale === "pl") return pl_invite_co_organizer(inputs)
	if (locale === "uk") return uk_invite_co_organizer(inputs)
	if (locale === "hi") return hi_invite_co_organizer(inputs)
	if (locale === "ar") return ar_invite_co_organizer(inputs)
	if (locale === "ms") return ms_invite_co_organizer(inputs)
	if (locale === "bn") return bn_invite_co_organizer(inputs)
	if (locale === "zh-TW") return zh_tw2_invite_co_organizer(inputs)
	if (locale === "zh-HK") return zh_hk2_invite_co_organizer(inputs)
	if (locale === "ur") return ur_invite_co_organizer(inputs)
	if (locale === "fa") return fa_invite_co_organizer(inputs)
	if (locale === "sw") return sw_invite_co_organizer(inputs)
	if (locale === "nl") return nl_invite_co_organizer(inputs)
	return en_invite_co_organizer(inputs)
});